import React from "react";
import LegalLayout, { LegalSection, LegalSub, LegalList, LegalCallout, Field } from "../../components/LegalLayout";
import SEO from "../../components/SEO";
import { COMPANY } from "../../config/COMPANY-INFO";

export default function TermsPage() {
  return (
    <>
      <SEO
        title="Obchodní podmínky"
        description="Obchodní podmínky pro rezervaci a poskytování detailingových služeb Apex Detailing v Praze a okolí."
        path="/pravni/obchodni-podminky"
      />
      <LegalLayout
      title="Obchodní podmínky"
      subtitle="Podmínky pro rezervaci a poskytování detailingových služeb prostřednictvím webu apex-detailing."
      testId="page-terms"
    >
      <LegalSection id="provozovatel" title="1. Provozovatel">
        <p>
          Tyto obchodní podmínky upravují vztahy mezi provozovatelem služby <strong>{COMPANY.tradeName}</strong> (dále jen „Poskytovatel“) a osobou, která si prostřednictvím webových stránek objedná detailingovou službu (dále jen „Zákazník“).
        </p>
        <LegalList>
          <li>Jméno / Obchodní firma: <Field value={COMPANY.legalName} name="obchodní jméno" /></li>
          <li>IČO: <Field value={COMPANY.ico} name="IČO" /></li>
          <li>Sídlo / místo podnikání: <strong>{COMPANY.address.full}</strong></li>
          <li>
            {COMPANY.legalForm === "sro" ? (
              <>Zapsáno v obchodním rejstříku: <Field value={`${COMPANY.commercialRegister.court} ${COMPANY.commercialRegister.fileNumber}`.trim()} name="OR" /></>
            ) : (
              <>Zapsáno v živnostenském rejstříku: <Field value={`${COMPANY.tradeRegister.office} ${COMPANY.tradeRegister.fileNumber}`.trim()} name="ŽR" /></>
            )}
          </li>
          <li>E-mail: <a href={`mailto:${COMPANY.contact.email}`} className="text-apex-gold hover:underline">{COMPANY.contact.email}</a></li>
          <li>Telefon: <a href={`tel:${COMPANY.contact.phoneRaw}`} className="text-apex-gold hover:underline">{COMPANY.contact.phone}</a></li>
        </LegalList>
      </LegalSection>

      <LegalSection id="predmet" title="2. Předmět smluvního vztahu">
        <p>
          Poskytovatel nabízí detailingové služby v rozsahu uvedeném v aktuálním ceníku na webu — zejména mytí a péči o exteriér, čištění interiéru a kompletní balíčky v řadách <strong>CLASSIC</strong> a <strong>PREMIUM</strong>, včetně příplatkových služeb uvedených v ceníku.
        </p>
        <p>
          Služby jsou poskytovány primárně jako mobilní služba u Zákazníka. Poskytovatel pracuje bezoplachovou metodou, díky které není na místě potřeba přístup k vodě — postačí přístup k elektrické zásuvce. Po dohodě lze službu provést i v samoobslužném mycím boxu.
        </p>
        <p>
          Dojezd je v ceně služby do 25 km od Zelenče, pokud hodnota objednávky přesahuje 2 400 Kč. U objednávek nižší hodnoty je účtován příplatek za dojezd ve výši 400 Kč. Při vzdálenosti nad 25 km je dojezd řešen individuální dohodou se Zákazníkem.
        </p>
      </LegalSection>

      <LegalSection id="objednavka" title="3. Objednávka a uzavření smlouvy">
        <LegalSub title="3.1 Rezervační proces">
          <p>
            Zákazník vytváří závaznou poptávku prostřednictvím rezervačního formuláře na webu — zvolí službu, doplňkové úpravy, termín a místo konání, a uvede své kontaktní údaje. Odesláním poptávky Zákazník výslovně souhlasí s těmito obchodními podmínkami a se zpracováním osobních údajů dle{" "}
            <a href="/pravni/ochrana-osobnich-udaju" className="text-apex-gold hover:underline">Zásad ochrany osobních údajů</a>.
          </p>
        </LegalSub>
        <LegalSub title="3.2 Potvrzení termínu">
          <p>
            Smlouva je uzavřena okamžikem, kdy Poskytovatel rezervaci potvrdí. Potvrzení je Zákazníkovi odesláno e-mailem bezprostředně po odeslání rezervace. Není-li Poskytovatel schopen termín poskytnout, nabídne Zákazníkovi alternativní termín nebo rezervaci zamítne s uvedením důvodu.
          </p>
        </LegalSub>
        <LegalSub title="3.3 Údaje vyplněné v rezervaci">
          <p>
            Zákazník odpovídá za správnost údajů poskytnutých při rezervaci (značka a model vozidla, adresa pro mobilní službu, kontakty). Poskytovatel není odpovědný za nemožnost poskytnutí služby z důvodu nepravdivých nebo chybějících údajů.
          </p>
        </LegalSub>
        <LegalSub title="3.4 Objednávka telefonicky nebo zprávou">
          <p>
            Objednávku lze učinit také telefonicky nebo prostřednictvím textové zprávy (SMS, WhatsApp, e-mail). V takovém případě Poskytovatel zašle Zákazníkovi písemný souhrn objednávky obsahující rozsah služby, cenu, termín, místo plnění a odkaz na tyto obchodní podmínky. Smlouva je uzavřena okamžikem, kdy Zákazník tento souhrn potvrdí odpovědí. Potvrzením souhrnu Zákazník zároveň potvrzuje, že se seznámil s těmito obchodními podmínkami a se Zásadami ochrany osobních údajů.
          </p>
        </LegalSub>
      </LegalSection>

      <LegalSection id="cena-platba" title="4. Cena a platební podmínky">
        <p>
          Ceny služeb jsou uvedeny v <a href="/#cenik" className="text-apex-gold hover:underline">ceníku na webu</a> v Kč včetně všech daní {COMPANY.isVatPayer ? "(plátce DPH)" : "(neplátce DPH)"}. Konečná cena se může lišit od orientační ceny v ceníku v závislosti na velikosti vozidla (osobní / SUV / VAN), stavu znečištění a zvolených doplňkových službách.
        </p>
        <p>
          Při extrémním znečištění vozu (např. po stavebních pracích, přepravě zvířat velkého množství či dlouhodobě neudržovaném vozidle) si Poskytovatel vyhrazuje právo naúčtovat přiměřený příplatek, který je se Zákazníkem předem dohodnut.
        </p>
        <LegalSub title="4.1 Způsoby platby">
          <LegalList>
            <li><strong>Online platba kartou</strong> přes platební bránu <strong>Stripe</strong> — po potvrzení termínu Zákazník obdrží odkaz na zabezpečenou platební stránku.</li>
            <li><strong>Platba na místě</strong> — hotově nebo kartou v okamžiku poskytnutí služby.</li>
          </LegalList>
        </LegalSub>
        <LegalSub title="4.2 Účtenka">
          <p>
            Po dokončení a uhrazení služby je Zákazníkovi automaticky vygenerována účtenka v elektronické podobě, dostupná v sekci „Mé rezervace“ a v potvrzovacím e-mailu.
          </p>
        </LegalSub>
      </LegalSection>

      <LegalSection id="odstoupeni" title="5. Odstoupení od smlouvy do 14 dnů">
        <LegalSub title="5.1 Právo odstoupit">
          <p>
            Zákazník, který je spotřebitelem, má právo odstoupit od smlouvy uzavřené prostřednictvím webu, telefonicky, zprávou nebo osobně mimo provozovnu Poskytovatele, a to bez udání důvodu ve lhůtě <strong>14 dnů</strong> ode dne uzavření smlouvy (§ 1829 občanského zákoníku).
          </p>
        </LegalSub>
        <LegalSub title="5.2 Jak odstoupit">
          <p>
            Odstoupení stačí odeslat Poskytovateli před uplynutím lhůty, a to e-mailem na{" "}
            <a href={`mailto:${COMPANY.contact.email}`} className="text-apex-gold hover:underline">{COMPANY.contact.email}</a>, písemně na adresu sídla, nebo prostřednictvím vzorového formuláře níže. Použití formuláře není povinné.
          </p>
        </LegalSub>
        <LegalSub title="5.3 Zahájení plnění před uplynutím lhůty">
          <p>
            Pokud si Zákazník zvolí termín provedení služby, který nastane dříve než za 14 dnů od uzavření smlouvy, vyslovuje tím výslovnou žádost, aby Poskytovatel začal s plněním ještě před uplynutím lhůty pro odstoupení. Zákazník bere na vědomí, že úplným provedením služby jeho právo odstoupit od smlouvy zaniká (§ 1837 písm. a) občanského zákoníku). Odstoupí-li Zákazník poté, co již bylo s plněním započato, ale před jeho dokončením, uhradí Poskytovateli poměrnou část ceny odpovídající rozsahu již poskytnutého plnění.
          </p>
        </LegalSub>
        <LegalSub title="5.4 Vrácení platby">
          <p>
            Odstoupí-li Zákazník řádně a včas, vrátí mu Poskytovatel veškeré uhrazené prostředky nejpozději do 14 dnů od doručení odstoupení, a to stejným způsobem, jakým byla platba přijata.
          </p>
        </LegalSub>
        <LegalSub title="5.5 Vzorový formulář pro odstoupení od smlouvy">
          <p className="text-sm text-apex-cream/60">(vyplňte a odešlete pouze v případě, že chcete odstoupit od smlouvy)</p>
          <div className="mt-3 rounded-2xl border border-apex-line bg-apex-card p-5 text-sm leading-relaxed">
            <p>Adresát: <strong>{COMPANY.legalName}</strong>, {COMPANY.address.full}, {COMPANY.contact.email}</p>
            <p className="mt-3">Oznamuji, že tímto odstupuji od smlouvy o poskytnutí služby:</p>
            <p className="mt-3">Objednaná služba: ..............................</p>
            <p>Datum objednání: ..............................</p>
            <p>Sjednaný termín: ..............................</p>
            <p>Jméno a příjmení spotřebitele: ..............................</p>
            <p>Adresa spotřebitele: ..............................</p>
            <p>Datum: ..............................</p>
            <p>Podpis (pouze pokud je formulář zasílán v listinné podobě): ......................</p>
          </div>
        </LegalSub>
      </LegalSection>

      <LegalSection id="zruseni" title="6. Zrušení rezervace, storno podmínky">
        <LegalSub title="6.1 Zrušení Zákazníkem">
          <p>Zákazník může rezervaci zrušit ve své sekci „Mé rezervace“, e-mailem nebo telefonicky.</p>
          <LegalList>
            <li><strong>Více než 24 hodin před termínem:</strong> bez poplatku. Již uhrazená částka se vrací v plné výši zpět na původní platební metodu, nejpozději do 14 dnů.</li>
            <li><strong>Méně než 24 hodin před termínem, nebo nedostaví-li se Zákazník k termínu:</strong> Poskytovatel je oprávněn účtovat storno poplatek ve výši 50 % z ceny objednané služby jako náhradu za termín, který již nelze obsadit. U předem uhrazených objednávek se poplatek započte a zbývající částka se vrací.</li>
          </LegalList>
          <p>
            Storno poplatek se neuplatní, pokud Zákazník odstoupí od smlouvy v zákonné 14denní lhůtě podle § 5 těchto podmínek a služba dosud nebyla provedena.
          </p>
        </LegalSub>
        <LegalSub title="6.2 Zrušení Poskytovatelem">
          <p>
            Poskytovatel může zamítnout rezervaci v případě nedostatku volné kapacity, vážného důvodu na straně provozu (nemoc, oprava vybavení), nebo zjevně chybně vyplněné poptávky. V takovém případě Zákazník obdrží e-mail s důvodem a případně s návrhem náhradního termínu; veškeré již uhrazené prostředky jsou vráceny v plné výši nejpozději do 14 dnů.
          </p>
        </LegalSub>
      </LegalSection>

      <LegalSection id="prubeh" title="7. Průběh služby a předání vozidla">
        <LegalList>
          <li>Zákazník se dostaví na sjednaný termín. Při zpoždění o více než 30 minut bez předchozí domluvy se rezervace považuje za nedostavenou.</li>
          <li>Zákazník odpovídá za odstranění cenných předmětů z vozidla. Poskytovatel neodpovídá za ztrátu osobních věcí ponechaných v interiéru.</li>
          <li>Před zahájením prací Poskytovatel s vozidlem provede vstupní kontrolu, pořídí fotodokumentaci jeho stavu a upozorní na existující závady, které by nemohl odstranit nebo které by mohly být detailingovým procesem zvýrazněny. Na vyžádání Poskytovatel fotodokumentaci Zákazníkovi zpřístupní.</li>
          <li>Po dokončení služby Poskytovatel pořídí fotodokumentaci výsledného stavu vozidla. Fotodokumentace z obou kroků slouží k doložení stavu vozidla při předání.</li>
          <li>Po dokončení je vůz předán Zákazníkovi k převzetí. Zákazník je oprávněn výsledek zkontrolovat na místě; případné zjevné nedostatky Poskytovatel odstraní ihned. Tím není dotčeno právo Zákazníka uplatnit vady později v zákonné lhůtě podle <a href="/pravni/reklamacni-rad" className="text-apex-gold hover:underline">Reklamačního řádu</a>.</li>
        </LegalList>
      </LegalSection>

      <LegalSection id="odpovednost-skoda" title="8. Odpovědnost za škodu na vozidle">
        <p>
          Poskytovatel odpovídá za škodu, kterou na vozidle Zákazníka způsobí porušením své povinnosti při poskytování služby. Poskytovatel je pro tento účel pojištěn pro případ odpovědnosti za újmu způsobenou při výkonu podnikatelské činnosti.
        </p>
        <p>Poskytovatel neodpovídá za:</p>
        <LegalList>
          <li>poškození, která na vozidle existovala již před zahájením prací a byla zachycena ve vstupní kontrole a fotodokumentaci,</li>
          <li>následky předchozích neodborných oprav, přelakování nebo aplikace nevhodných přípravků, které se mohou při detailingu projevit,</li>
          <li>poškození vzniklá skrytou vadou vozidla, na kterou Zákazník neupozornil (např. netěsnost, poškozená elektroinstalace, uvolněné díly),</li>
          <li>ztrátu nebo poškození osobních věcí ponechaných ve vozidle.</li>
        </LegalList>
        <p>
          Škodu je Zákazník povinen uplatnit bez zbytečného odkladu po jejím zjištění. Postup se řídí <a href="/pravni/reklamacni-rad" className="text-apex-gold hover:underline">Reklamačním řádem</a>.
        </p>
      </LegalSection>

      <LegalSection id="odpovednost" title="9. Odpovědnost za vady, záruka">
        <p>
          Poskytovatel odpovídá za řádné provedení sjednané služby. V případě, že služba neodpovídá popisu uvedenému v rezervaci, má Zákazník právo na bezplatné odstranění vady v dohodnutém termínu, případně na přiměřenou slevu z ceny.
        </p>
        <p>
          Záruka se nevztahuje na vady vzniklé nešetrným zacházením po předání vozidla, na opotřebení v důsledku běžného provozu vozidla, nebo na vady existující již před zahájením služby a uvedené ve vstupní kontrole.
        </p>
        <p>
          Postup uplatnění reklamace je popsán v samostatném dokumentu — <a href="/pravni/reklamacni-rad" className="text-apex-gold hover:underline">Reklamační řád</a>.
        </p>
      </LegalSection>

      <LegalSection id="osobni-udaje" title="10. Ochrana osobních údajů">
        <p>
          Zpracování osobních údajů Zákazníka při rezervaci, platbě a komunikaci se řídí samostatným dokumentem{" "}
          <a href="/pravni/ochrana-osobnich-udaju" className="text-apex-gold hover:underline">Zásady ochrany osobních údajů (GDPR)</a>, který Zákazník odesláním poptávky bere na vědomí.
        </p>
      </LegalSection>

      <LegalSection id="reseni-sporu" title="11. Řešení sporů">
        <p>
          Veškeré vzájemné spory se Poskytovatel a Zákazník zavazují přednostně řešit smírnou cestou. Pokud k dohodě nedojde, je Zákazník (jako spotřebitel) oprávněn obrátit se na <strong>Českou obchodní inspekci</strong> (ČOI) jakožto subjekt mimosoudního řešení spotřebitelských sporů — viz <a href="/pravni/reseni-sporu" className="text-apex-gold hover:underline">stránka ADR</a>.
        </p>
      </LegalSection>

      <LegalSection id="zaverecne" title="12. Závěrečná ustanovení">
        <p>
          Vztahy neupravené těmito obchodními podmínkami se řídí zejména zákonem č. 89/2012 Sb. (občanský zákoník) a zákonem č. 634/1992 Sb. (o ochraně spotřebitele) v platném znění.
        </p>
        <p>
          Poskytovatel si vyhrazuje právo tyto obchodní podmínky kdykoliv změnit. Pro již potvrzené rezervace se vždy uplatní znění platné v okamžiku potvrzení termínu.
        </p>
        <LegalCallout>
          Tyto obchodní podmínky nabývají účinnosti dnem <strong>{COMPANY.effectiveDate}</strong>.
        </LegalCallout>
      </LegalSection>
    </LegalLayout>
    </>
  );
}
